<div [ngClass]="breadcrumbNodes.length > 0 ? 'pt-2' : 'pt-3'" class="px-3 dashboards-page">
  <mat-card appearance="outlined" class="mb-3">
    <mat-card-content class="d-flex justify-content-sm-between flex-wrap gap-10">
      <div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'field.search' | translate }}</mat-label>
          <input matInput [formControl]="searchControl" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      <div class="d-flex gap-10 justify-content-sm-between align-items-center flex-wrap">
        <mat-button-toggle-group
          class="items-toggle-button-container"
          [formControl]="viewModeControl"
          [hideSingleSelectionIndicator]="true"
        >
          <mat-button-toggle class="items-toggle-button" [value]="EDashboardViewMode.all">
            {{ 'field.all' | translate }}
          </mat-button-toggle>
          <mat-button-toggle class="items-toggle-button" [value]="EDashboardViewMode.onlyVisible">
            {{ 'field.dashboards' | translate }}
          </mat-button-toggle>
          <mat-button-toggle class="items-toggle-button" [value]="EDashboardViewMode.onlySubDashboards">
            {{ 'field.subDashboards' | translate }}
          </mat-button-toggle>
          <mat-button-toggle class="items-toggle-button" [value]="EDashboardViewMode.slideshows">
            {{ 'page.slideshows.title' | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
        <mat-dropdown
          class="view-mode-dropdown"
          [options]="viewModeOptions"
          [configurationInput]="viewModeDropdownConfig"
          [formControl]="viewModeDropdownControl"
        ></mat-dropdown>
        <button
          mat-icon-button
          class="sort-menu-trigger"
          [matMenuTriggerFor]="sortMenu"
          [matTooltip]="'field.sortBy' | translate"
        >
          <mat-icon>sort</mat-icon>
        </button>
        <button *ngIf="this.isToolAdmin" mat-flat-button (click)="onAddButtonClicked()">
          <mat-icon>add</mat-icon>
          {{
            'button.addContext'
              | translate: { context: ((isSlideshowsMode ? 'field.slideshow' : 'field.dashboard') | translate) }
          }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
  @if (isAllMode) {
    <div class="items-group-header">
      <div class="items-group-icon">
        <mat-icon class="material-icons-outlined">dashboard</mat-icon>
      </div>
      <span class="items-group-label">{{ 'field.dashboards' | translate }}</span>
    </div>
  }
  <div *ngIf="!isSlideshowsMode" class="row" [class.pt-2]="breadcrumbNodes.length > 0">
    @for (item of formattedDatatableRows(); track item) {
      <div class="col-lg-3 col-sm-6 col-xs-12 mb-3">
        <mat-card appearance="outlined" class="dashboard-card">
          <mat-card-header>
            <div mat-card-avatar class="pe-1 pt-3 ps-3">
              <img height="40px" src="../../assets/images/modules/digitalBoards.png" />
            </div>
            <mat-card-title class="f-16 pt-3 text-truncate">{{ item.name }}</mat-card-title>
            <mat-card-subtitle class="f-12 text-grey">{{ item.workspace }}</mat-card-subtitle>
            <div class="card-header-actions">
              <button
                mat-icon-button
                class="card-pin-button"
                [class.pinned]="item.isPinned"
                (click)="togglePin(item)"
                [matTooltip]="(item.isPinned ? 'button.unpin' : 'button.pin') | translate"
              >
                <mat-icon [class.material-icons-outlined]="!item.isPinned">push_pin</mat-icon>
              </button>
              @if (item.isCurrentUserAdmin) {
                <button mat-icon-button (click)="onClickedItem(item.id)" [matMenuTriggerFor]="settingsMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
              }
            </div>
          </mat-card-header>
          <mat-card-actions class="card-actions-with-chips">
            <div class="card-chip-container">
              <span class="card-chip">
                <mat-icon class="material-icons-outlined">{{ item.isPrivate ? 'person' : 'group' }}</mat-icon>
                {{ (item.isPrivate ? 'field.private' : 'field.shared') | translate }}
              </span>
              @if (item.isAutoLockConfigured) {
                <span class="card-chip">
                  <mat-icon class="material-icons-outlined">lock</mat-icon>
                  {{ 'field.autoLock' | translate }}
                </span>
              }
            </div>
            <div class="card-actions-buttons">
              @if (item.hasVisibleChildren) {
                <button
                  mat-button
                  class="me-2 d-inline-flex align-items-center"
                  color="primary"
                  (click)="openChildDashboards(item)"
                  [matTooltip]="'button.showChildDashboards' | translate"
                >
                  <mat-icon class="m-0 material-icons-outlined">account_tree</mat-icon>
                </button>
              }

              <a [routerLink]="dashboardsRoute.content(item.id)">
                <button mat-stroked-button>
                  {{ 'button.open' | translate }}
                </button>
              </a>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    }
  </div>
  @if (isSlideshowsMode || isAllMode) {
    @if (isAllMode) {
      <div class="items-group-header">
        <div class="items-group-icon">
          <mat-icon class="material-icons-outlined">slideshow</mat-icon>
        </div>
        <span class="items-group-label">{{ 'page.slideshows.title' | translate }}</span>
      </div>
    }
    <app-slideshows [externalSearchControl]="searchControl" [externalSortOption]="sortOption()" />
  }
  <mat-menu class="mt-2 sort-options-menu" #sortMenu="matMenu">
    @for (option of sortOptions; track option.id) {
      <button mat-menu-item (click)="onSortOptionSelected(option.id)">
        <mat-icon [style.visibility]="sortOption() === option.id ? 'visible' : 'hidden'">check</mat-icon>
        <span>{{ option.labelKey | translate }}</span>
      </button>
    }
  </mat-menu>
  <mat-menu class="mt-2" #settingsMenu="matMenu">
    <button mat-menu-item (click)="initializeEdit()">
      {{ 'button.edit' | translate }}
    </button>
    <button *ngIf="isToolAdmin" mat-menu-item (click)="initializeClone()">
      {{ 'button.clone' | translate }}
    </button>
    <button mat-menu-item (click)="initializeDelete()">
      {{ 'button.delete' | translate }}
    </button>
  </mat-menu>
</div>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 mb-3">
          <span class="dialog-section"
            ><mat-icon>description</mat-icon> {{ 'system.dialogSection.generalInformation' | translate }}</span
          >
        </div>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <div class="col-lg-12">
          <mat-dropdown
            [options]="store.workspaces()"
            [configurationInput]="workspaceDropdownConfig"
            [formControl]="addEditForm.controls.workspace"
            [isLoading]="(store.workspacesLoading$ | async) === store.ELoadStatus.loading"
            [isFormSubmitted]="form.submitted"
            (selected)="onSelectedWorkspace()"
            (search)="getWorkspaces($event)"
          ></mat-dropdown>
        </div>
        <div class="col-lg-12">
          <mat-dropdown
            [options]="store.parentsOptions()"
            [configurationInput]="parentDropdownSettings"
            [formControl]="addEditForm.controls.parent"
            [isLoading]="(store.parentsLoading$ | async) === store.ELoadStatus.loading"
            (search)="getParentDashboards($event)"
          ></mat-dropdown>
        </div>

        <div class="col-12 mb-2">
          <mat-expansion-panel [expanded]="isExtendedDisplayConfigurationPanel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="me-2">display_settings</mat-icon>
                {{ 'system.dialogSection.displayConfiguration' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="bulk-dialog-field">
              <mat-dropdown
                class="w-100"
                [configurationInput]="refreshIntervalDropdownConfiguration"
                [formControl]="addEditForm.controls.refreshInterval"
                [options]="refreshIntervalData"
                [isFormSubmitted]="form.submitted"
              >
              </mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-dropdown
                [options]="layoutOptions"
                [configurationInput]="{
                  enableSearchFilter: false,
                  hasMatError: true,
                  isClientSide: true,
                  repositionDropdownList: true,
                  singleSelection: true,
                  text: this.translate.instant('field.layout'),
                }"
                [formControl]="addEditForm.controls.layoutMode"
                [isFormSubmitted]="form.submitted"
              ></mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-checkbox [formControl]="addEditForm.controls.isHidden">
                {{ 'field.subDashboard' | translate }}
              </mat-checkbox>
            </div>
            <div class="col-lg-12">
              <mat-checkbox [formControl]="addEditForm.controls.isWidgetFilterButtonHidden">
                {{ 'field.hideWidgetFilterButton' | translate }}
              </mat-checkbox>
            </div>
          </mat-expansion-panel>
        </div>

        <div class="col-12">
          <mat-expansion-panel [expanded]="isExtendedAccessPanel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="me-2 material-icons-outlined">groups</mat-icon>
                {{ 'system.dialogSection.accessAndPermissions' | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="col-lg-12">
              <mat-dropdown
                [isFormSubmitted]="form.submitted"
                [options]="store.adminOptions()"
                [configurationInput]="{
                  text: ('field.canEdit' | translate),
                  repositionDropdownList: true,
                  hasDelayedDefaultValue: true,
                }"
                [formControl]="addEditForm.controls.admins"
                [isLoading]="(store.adminOptionsLoading$ | async) === store.ELoadStatus.loading"
                (search)="getAdmins($event)"
              ></mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-dropdown
                [options]="store.userOptions()"
                [configurationInput]="{
                  text: ('field.canView' | translate),
                  repositionDropdownList: true,
                  hasDelayedDefaultValue: true,
                }"
                [formControl]="addEditForm.controls.users"
                [isLoading]="(store.userOptionsLoading$ | async) === store.ELoadStatus.loading"
                (search)="getUsers($event)"
              ></mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-dropdown
                [options]="store.teamOptions()"
                [configurationInput]="{
                  text: ('field.teamsCanView' | translate),
                  repositionDropdownList: true,
                  hasDelayedDefaultValue: true,
                }"
                [formControl]="addEditForm.controls.teams"
                [isLoading]="(store.teamOptionsLoading$ | async) === store.ELoadStatus.loading"
                (search)="getTeams($event)"
              ></mat-dropdown>
            </div>
            <div class="col-lg-12">
              <mat-checkbox [formControl]="addEditForm.controls.isPublished">
                {{ 'field.publishWorkspaceUsers' | translate }}
              </mat-checkbox>
            </div>
          </mat-expansion-panel>
        </div>

        <div class="col-12 mt-2">
          <app-screen-lock-configuration
            [durationControl]="addEditForm.controls.autoLockDuration"
            [pinControl]="addEditForm.controls.autoLockPin"
            [isExpanded]="isExtendedScreenLockPanel"
            [isFormSubmitted]="form.submitted"
            [isAutoLockConfigured]="isAutoLockConfigured"
          ></app-screen-lock-configuration>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
